import { Button } from "components/atoms/button/button";
import styled from "styled-components";
import { sizes } from "styles";

export const ClassCardContainer = styled.section`
  position: relative;
  width: ${sizes.kelasLive.heroSectionUpcomingClassCardWidth};
`;

export const ClassTagContainer = styled.div<{ backgroundColor: string }>`
  position: relative;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  color: ${({ theme }) => theme.colors.brand["800"]};
  font-size: ${({ theme }) => theme.fontSizes.xl};
  font-weight: bold;
`;

export const ClassCard = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  box-shadow: 0px 0px 32px ${({ theme }) => theme.colors.transparent.white10};
  display: flex;
  overflow: hidden;
  width: ${sizes.kelasLive.heroSectionUpcomingClassCardWidth};
  position: relative;
`;

export const ClassCardImageContainer = styled.div`
  flex-basis: 40%;
`;

export const ClassCardImageWrapper = styled.figure`
  margin: 0;
  padding: 100% 0 0 0;
  position: relative;
  border-radius: 8px;
  border-top-left-radius: 0px;
  overflow: hidden;
`;
export const ClassCardDetails = styled.div`
  padding: 40px;
  position: relative;
  width: 100%;
`;

export const ClassCardTopicsContainer = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ClassCardDetailsHeading = styled.h3`
  margin: 16px 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  color: ${({ theme }) => theme.colors.black};
  line-height: 1.3;
`;

export const ClassCardTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
`;

export const ClassCardDetailsContent = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ClassCardDetailsTeacherContainer = styled.div``;

export const ClassCardDetailsTeacher = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["xl"]};
  color: ${({ theme }) => theme.colors.black};
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ClassCardInfoItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const ClassCardInfoItem = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  color: ${({ theme }) => theme.colors.neutral[600]};
  margin: 0;
  &:not(:last-child) {
    &:after {
      content: "•";
      margin: 0 4px;
      font-size: ${({ theme }) => theme.fontSizes["md"]};
      color: ${({ theme }) => theme.colors.neutral[600]};
    }
  }
`;

export const ClassCardTimer = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  color: ${({ theme }) => theme.colors.neutral[600]};
  font-weight: bold;
  margin-top: 24px;
`;

export const ClassCardTimerHighlight = styled.span`
  color: ${({ theme }) => theme.colors.brand[500]};
  background: ${({ theme }) => theme.colors.yellow[200]};
  border-radius: 4px;
  padding: 2px 4px;
`;

export const ClassCardTimerDots = styled.span`
  color: ${({ theme }) => theme.colors.brand[500]};
  margin: 0 4px;
`;

export const StyledButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.neutral[400]};
  &:hover {
    background-color: ${({ theme }) => theme.colors.neutral[400]};
  }
`;
